import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const AppSettings = ({
  color = 'icon.primary',
  strokeWidth = '2.5',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 40 40' {...props}>
    <Path
      d='M21.8893 15.3963C23.8813 17.3882 23.8813
          20.6162 21.8893 22.6081C19.8974 24.6 16.6695 24.6
          14.6776 22.6081C12.6856 20.6162 12.6856 17.3882
          14.6776 15.3963C16.6675 13.4044 19.8974 13.4044
          21.8893 15.3963'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d='M31.0318 18.9995C31.0318 18.4375 30.9818 17.8776 30.9138
          17.3336L33.9137 14.9876C34.5777 14.4656 34.7597 13.5357 34.3377
          12.8037L31.6698 8.18983C31.2478 7.45985 30.3538 7.15186 29.5699
          7.46385L26.8899 8.53982C26.3579 8.75381
          25.764 8.66381 25.284 8.34782C24.868 8.07383 24.44 7.82384
          23.996 7.59984C23.484 7.34385 23.11 6.87586 23.028 6.30988L22.62
          3.45396C22.5021 2.61998 21.7861 2 20.9421 2H15.6222C14.7803
          2 14.0643 2.61998 13.9443 3.45396L13.5323
          6.31388C13.4523 6.87786 13.0803 7.34385 12.5723 7.60184C12.1263
          7.82984 11.6944 8.08383 11.2804 8.35782C10.8024 8.67181 10.2104
          8.75581 9.68041 8.54382L6.99649 7.46385C6.21251 7.14986 5.31654
          7.45785 4.89655 8.18983L2.22862 12.8037C1.80463 13.5357 1.98663
          14.4676 2.65061 14.9876L5.65053 17.3336C5.58253
          17.8776 5.53053 18.4375 5.53053 18.9995C5.53053 19.5595 5.58053
          20.1215 5.65053 20.6655L2.65061 23.0114C1.98663 23.5334 1.80463
          24.4634 2.22662 25.1953L4.89455 29.8092C5.31654 30.5392
          6.21051 30.8472 6.99449 30.5352L9.68041 29.4572C10.2104
          29.2432 10.8024 29.3292 11.2784 29.6452C11.6944 29.9212
          12.1243 30.1732 12.5703 30.4012C13.0803 30.6592 13.4503
          31.1232 13.5323 31.6892L13.9423 34.5471C14.0623 35.3791
          14.7783 35.999 15.6202 35.999H18.2822'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d='M25.9971 28.0019H37.9967'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d='M25.9971 33.0009H37.9967'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d='M25.9971 37.999H37.9967'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
  </IconBase>
)

AppSettings.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default AppSettings
